import React from "react";
import Container from "../../hoc/Container";
import { tgIcon } from "../../../images";

function SteamInfo() {
  return (
    <Container>
      <article className="content-block-no-top-bottom-padding">
        <section className="my-5">
          <h3 className="my-2 text-center text-2xl overline decoration-sky-500">
            Боты для покупки карт оплаты
          </h3>
          <div
            onClick={() => window.ym(93997310, "reachGoal", "tgClickSteam")}
            className="flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-4 md:flex-col md:gap-2"
          >
            <a
              href={"https://t.me/trendy_steam_bot?start=ref-001"}
              className="flex w-40 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              target="_blank"
              rel="noreferrer"
            >
              Купить в <img src={tgIcon} alt="TG" className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
            </a>
          </div>
        </section>
        <section className="my-5">
          <h3 className="my-2 text-center text-2xl overline decoration-sky-500">
            Описание
          </h3>
          <p className="dark-text my-3 w-full text-justify indent-4 text-gray-700">
            В нашем магазине вы можете купить карты пополнения Steam для аккаунтов
            разных регионов. Выберите нужный регион, затем номинал и оформите
            покупку. После оплаты вы получите код для активации в Steam.
          </p>
          <p className="dark-text my-3 w-full text-justify indent-4 text-gray-700">
            Если нужна помощь с выбором региона или активацией, напишите в
            поддержку или воспользуйтесь ботом в Telegram — там есть быстрые
            инструкции и ответы на частые вопросы.
          </p>
        </section>
        <section className="my-5">
          <h3 className="my-2 text-center text-2xl">Как активировать карту</h3>
          <p className="dark-text my-3 w-full text-justify indent-4 text-gray-700">
            Откройте клиент Steam, перейдите в раздел «Игры» → «Активировать
            продукт в Steam» и введите полученный код. Средства будут начислены на
            баланс аккаунта Steam.
          </p>
        </section>
      </article>
    </Container>
  );
}

export default SteamInfo;
